// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"224":"f418160d","238":"ade87e77","686":"b79c90c9"}[chunkId] + ".chunk.js";
};